<template>
  <v-app>
    <v-container v-if="object" class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'cogs']" />
        <router-link :to="{ name: 'settings_loose_ends' }">
          <font-awesome-icon
            :icon="['fas', 'code-branch']"
            :style="{ color: 'green' }"
        /></router-link>
        <font-awesome-icon :icon="['fas', 'balance-scale']" />
        <span class="title">Loose ends, settings for manually merging (M)</span>
      </Header>
      <v-row>
        <v-col class="col-12">
          <v-card flat color="transparent">
            <v-card-text>
              <v-row class="rowbox">
                <v-col class="col-5">
                  <v-subheader><b>Maximum timespan</b></v-subheader>
                  <v-range-slider
                    v-model="range1"
                    :max="max"
                    :min="min"
                    class="align-center"
                    @change="ApiGet(false)"
                  >
                    <template v-slot:prepend>
                      <v-text-field
                        :value="range1[0]"
                        class="mt-0 pt-0"
                        single-line
                        type="number"
                        style="width: 60px"
                      ></v-text-field>
                    </template>
                    <template v-slot:append>
                      <v-text-field
                        :value="range1[1]"
                        class="mt-0 pt-0"
                        single-line
                        type="number"
                        style="width: 60px"
                      ></v-text-field>
                    </template>
                  </v-range-slider>
                </v-col>
                <v-col class="col-5">
                  <v-subheader>Maximum distance</v-subheader>
                  <v-range-slider
                    v-model="range2"
                    :max="max2"
                    :min="min2"
                    class="align-center"
                    @change="ApiGetx()"
                  >
                    <template v-slot:prepend>
                      <v-text-field
                        :value="range2[0]"
                        class="mt-0 pt-0"
                        single-line
                        type="number"
                        style="width: 60px"
                        @change="$set(range2, 0, $event)"
                      ></v-text-field>
                    </template>
                    <template v-slot:append>
                      <v-text-field
                        :value="range2[1]"
                        class="mt-0 pt-0"
                        single-line
                        type="number"
                        style="width: 60px"
                        @change="$set(range2, 1, $event)"
                      ></v-text-field>
                    </template>
                  </v-range-slider>
                </v-col>
                <v-col class="col-2"
                  ><br /><br />
                  <button
                    @click="
                      copySettings(
                        'field_loosem_distance',
                        range1[0],
                        'field_loosem_time',
                        range2[0]
                      )
                    "
                  >
                    Copy to settings
                  </button>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-6 Track1"
          ><ImageTrack
            v-if="imagetrackloaded"
            :obj="this.object.obj1"
            :frame="this.object.frame1"
            :mapid="map1"
          />
        </v-col>
        <v-col class="col-6"
          ><ImageTrack
            v-if="imagetrackloaded"
            :obj="this.object.obj2"
            :frame="this.object.frame2"
            :mapid="map2"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-6">
          <pagination
            class="pagination col-xs-12"
            v-model="o_slider"
            :total-page="n_objects"
            boundary-links
            pills
            size="lg"
            @change="changeObject(o_slider)"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import ProjectService from "@/services/ProjectService.js";
import Header from "@/components/Header.vue";
import ImageTrack from "@/components/ImageTrack.vue";
export default {
  components: {
    Header,
    ImageTrack
  },
  data: function() {
    return {
      object: null,
      range1: null,
      range2: null,
      routes: {},
      fields: {},
      objects: {},
      imagetrackloaded: false,
      map1: "map1",
      map2: "map2",
      n_traffic: 0,
      n_nontraffic: 0,
      n_objects: 0,
      min: 0,
      max: 100,
      min2: 0,
      max2: 200,
      stats: {},
      o_slider: 1,
      slider: 40,
      starttijd: 60
    };
  },
  created() {
    if (this.range1 == null) {
      ProjectService.apiGet({
        nid: this.$session.get("PROJID"),
        type: "get_ranges",
        option: "settings_loose_ends_m"
      })
        .then(response => {
          this.range1 = response.data.ranges.time;
          this.range2 = response.data.ranges.distance;
          this.ApiGet();
        })
        .catch(error => {
          console.log("Fout " + error.response);
        });
    }
  },
  methods: {
    ApiGetx() {
      this.ApiGet();
    },
    changeObject() {
      this.object = this.objects[this.o_slider];
    },
    ApiGet() {
      let ranges = {
        time: this.range1,
        distance: this.range2,
        automanual: "auto"
      };
      ProjectService.apiGet({
        nid: this.$session.get("PROJID"),
        type: "settings_loose_ends_m",
        ranges
      })
        .then(response => {
          this.objects = response.data.objects;
          this.n_objects = response.data.n;
          this.o_slider = 1;
          this.object = this.objects[this.o_slider];
          this.imagetrackloaded = true;
        })
        .catch(error => {
          console.log("Fout " + error.response);
        });
    },
    copySettings(field, value, field2, value2) {
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "update_fields",
        field,
        value,
        field2,
        value2
      });
    }
  }
};
</script>

<style scoped>
.align-center {
  border-style: solid;
  border-width: thin;
}
.button,
button {
  align-items: center;
  justify-content: center;
  width: 8em;
  height: 2em;
  margin-left: 0.5em;
  padding: none;
  border-radius: 5px;
  background: linear-gradient(to right, #16c0b0, #84cf6a);
  font-size: 1em;
  color: white;
  border: none;
  outline: none;
}
</style>
